import React from "react";
import styles from "./Input.module.scss";

const Input = ({ id, type, label, name, value, onChange, onKeydown, onKeyUp, onFocus, placeholder, isNumeric, isSearch }) => {
  return (
    <fieldset className={styles.Input}>
      <label>
        {
          label && <p>{ label }</p>
        }
        <input id={id} placeholder={placeholder} name={name} value={value} onChange={onChange} onKeyDown={onKeydown} onKeyUp={onKeyUp} onFocus={onFocus} type={isNumeric ? "number" : type ? type : "text"} className={isSearch && styles.searchInput} />
      </label>
    </fieldset>
  )
}

export default Input;